<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
                v-model="searchText"
                v-on:keyup.enter="searchData()"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i
            class="fa fa-search searchBtn ml-3 mt-1"
            title="ძებნა"
            @click="searchData()"
          ></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ორგანიზაციის ბრენდის დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameGeAdd"
                      class="form-control"
                      placeholder="სახელი ქართულად"
                      autofocus="autofocus"
                      v-model="legalBrand.nameGe"
                      v-on:input="$v.legalBrand.$touch"
                      v-bind:class="{
                        'error-border': $v.legalBrand.nameGe.$error,
                        valid:
                          $v.legalBrand.nameGe.$dirty &&
                          !$v.legalBrand.nameGe.$invalid,
                      }"
                    />
                    <label for="nameGeAdd">სახელი ქართულად</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameEnAdd"
                      class="form-control"
                      placeholder="English Name"
                      autofocus="autofocus"
                      v-model="legalBrand.nameEn"
                      v-on:input="$v.legalBrand.$touch"
                      v-bind:class="{
                        'error-border': $v.legalBrand.nameEn.$error,
                        valid:
                          $v.legalBrand.nameEn.$dirty &&
                          !$v.legalBrand.nameEn.$invalid,
                      }"
                    />
                    <label for="nameEnAdd">English Name</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameRuAdd"
                      class="form-control"
                      placeholder="имя на русском"
                      autofocus="autofocus"
                      v-model="legalBrand.nameRu"
                      v-on:input="$v.legalBrand.$touch"
                      v-bind:class="{
                        'error-border': $v.legalBrand.nameRu.$error,
                        valid:
                          $v.legalBrand.nameRu.$dirty &&
                          !$v.legalBrand.nameRu.$invalid,
                      }"
                    />
                    <label for="nameRuAdd">имя на русском</label>
                  </div>
                </div>
                <form v-if="!isActive" method="post" class="mt-3">
                  <div class="custom-file">
                    <input
                      type="file"
                      ref="file"
                      multiple
                      @change="onFileSelected"
                      class="custom-file-input"
                      id="validatedCustomFile"
                    />
                    <label
                      class="custom-file-label"
                      for="validatedCustomFile"
                    ></label>
                  </div>
                </form>
                <img
                  v-if="!isActive"
                  class="img-thumbnail mt-3"
                  v-bind:src="imagePreview"
                  v-show="showPreview"
                />
                <form v-if="isActive" method="post" class="mt-3">
                  <div class="custom-file">
                    <input
                      type="file"
                      ref="fileEdit"
                      @change="onFileSelectedEdit"
                      class="custom-file-input"
                      id="validatedCustomFileEdit"
                    />
                    <label
                      class="custom-file-label"
                      for="validatedCustomFileEdit"
                    ></label>
                  </div>
                </form>
                <img
                  v-if="!editImg && isActive"
                  class="img-thumbnail mt-3"
                  :src="imageUrl(mainImageUpuloadName)"
                />
                <img
                  v-if="editImg && isActive"
                  class="img-thumbnail mt-3"
                  v-bind:src="imagePreview"
                  v-show="showPreview"
                />
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <label for="descGeAdd">აღწერა ქართულად</label>
                  <textarea
                    class="form-control"
                    id="descGeAdd"
                    v-model="legalBrand.descGe"
                    v-on:input="$v.legalBrand.$touch"
                    v-bind:class="{
                      'error-border': $v.legalBrand.descGe.$error,
                      valid:
                        $v.legalBrand.descGe.$dirty &&
                        !$v.legalBrand.descGe.$invalid,
                    }"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label for="descEnAdd">Description</label>
                  <textarea
                    class="form-control"
                    id="descEnAdd"
                    v-model="legalBrand.descEn"
                    v-on:input="$v.legalBrand.$touch"
                    v-bind:class="{
                      'error-border': $v.legalBrand.descEn.$error,
                      valid:
                        $v.legalBrand.descEn.$dirty &&
                        !$v.legalBrand.descEn.$invalid,
                    }"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label for="descRuAdd">описание на русском</label>
                  <textarea
                    class="form-control"
                    id="descRuAdd"
                    v-model="legalBrand.descRu"
                    v-on:input="$v.legalBrand.$touch"
                    v-bind:class="{
                      'error-border': $v.legalBrand.descRu.$error,
                      valid:
                        $v.legalBrand.descRu.$dirty &&
                        !$v.legalBrand.descRu.$invalid,
                    }"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-label-group">
                  <div class="dropdown mt-3">
                    <button
                      class="btn green-color text-light dropdown-toggle"
                      type="button"
                      id="dropdownProductCategorySelect"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ dropDownLegalBrandCategory }}
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownProductCategorySelect"
                      style="max-height: 400px; overflow: hidden auto"
                    >
                      <a
                        class="dropdown-item pointer"
                        v-for="categoryValue in legalCategoriesArray"
                        :key="categoryValue.id"
                        v-on:focus="$v.legalBrand.$touch"
                        @click="
                          dropDownCategoryClick(
                            categoryValue.nameGe,
                            categoryValue.id
                          )
                        "
                        v-bind:class="{
                          'error-border': $v.legalBrand.lBCategoryId.$error,
                          valid:
                            $v.legalBrand.lBCategoryId.$dirty &&
                            !$v.legalBrand.lBCategoryId.$invalid,
                        }"
                        >{{ categoryValue.nameGe }}</a
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isActive"
              type="button"
              class="btn btn-success"
              :disabled="!$v.legalBrand.$dirty || $v.legalBrand.$error"
              @click="$v.legalBrand.$touch(), addLegalBrand()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActive"
              type="button"
              class="btn btn-success"
              :disabled="!$v.legalBrand.$dirty || $v.legalBrand.$error"
              @click="$v.legalBrand.$touch(), editLegalBrand()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი ქართულად</th>
            <th class="numeric">English Name</th>
            <th class="numeric">имя на русском</th>
            <th class="numeric">აღწერა ქართულად</th>
            <th class="numeric">Description Name</th>
            <th class="numeric">описание на русском</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="valueLegalBrand in filteredDataArray"
            :key="valueLegalBrand.id"
          >
            <td data-title="სახელი ქართულად" class="numeric">
              {{ valueLegalBrand.nameGe }}
            </td>
            <td data-title="English Name" class="numeric">
              {{ valueLegalBrand.nameEn }}
            </td>
            <td data-title="имя на русском" class="numeric">
              {{ valueLegalBrand.nameRu }}
            </td>
            <td data-title="აღწერა ქართულად" class="numeric">
              {{ valueLegalBrand.descGe }}
            </td>
            <td data-title="Description Name" class="numeric">
              {{ valueLegalBrand.descEn }}
            </td>
            <td data-title=">описание на русском" class="numeric">
              {{ valueLegalBrand.descRu }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  @click="editFillInputs(valueLegalBrand), modalPrepareEdit()"
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  @click="getDeleteId(valueLegalBrand.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ორგანიზაციის ბრენდის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteLegalBrand()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "products",
  data() {
    return {
      showModal: false,
      legalBrand: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        logoSrc: null,
        lBCategoryId: null,
      },
      legalBrandCategory: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        iconSrc: null,
      },
      isActive: false,
      mainImageUpuloadName: "აირჩიეთ ფაილი ...",
      dropDownLegalBrandCategory: "აირჩიეთ კატეგორია",
      showPreview: false,
      imagePreview: "",
      editImg: false,
      legalBrandsArray: [],
      legalCategoriesArray: [],
      filteredDataArray: [],
      searchText: null,
    };
  },
  validations: {
    legalBrand: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      descGe: {
        required,
      },
      descEn: {
        required,
      },
      descRu: {
        required,
      },
      logoSrc: {
        required,
      },
      lBCategoryId: {
        required,
      },
    },
  },
  async created() {
    let legalBrandResult = await this.$http.getLegalBrand();
    this.legalBrandsArray = legalBrandResult.data.res;
    this.filteredDataArray = this.legalBrandsArray;

    let legalCategoriesResult = await this.$http.getLegalBrandCategories();
    this.legalCategoriesArray = legalCategoriesResult.data.res;
  },
  methods: {
    async addLegalBrand() {
      try {
        let data = new FormData();

        data.append("nameGe", this.legalBrand.nameGe);
        data.append("nameEn", this.legalBrand.nameEn);
        data.append("nameRu", this.legalBrand.nameRu);
        data.append("descGe", this.legalBrand.descGe);
        data.append("descEn", this.legalBrand.descEn);
        data.append("descRu", this.legalBrand.descRu);
        data.append("logo", this.legalBrand.logoSrc);
        data.append("lBCategoryId", this.legalBrand.lBCategoryId);
        data.append("merchants", this.legalBrand.merchants);

        let legalBrandAddResult = await this.$http.postLegalBrand(data);

        if (legalBrandAddResult.data.resultCode === "200") {
          bus.$emit("success", "სპეციალური ნივთის წარმატებით დაემატა");
          let legalBrandResult = await this.$http.getLegalBrand();
          this.legalBrandsArray = legalBrandResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "სპეციალური ნივთის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editLegalBrand() {
      try {
        let data = new FormData();

        data.append("id", this.legalBrand.id);
        data.append("nameGe", this.legalBrand.nameGe);
        data.append("nameEn", this.legalBrand.nameEn);
        data.append("nameRu", this.legalBrand.nameRu);
        data.append("descGe", this.legalBrand.descGe);
        data.append("descEn", this.legalBrand.descEn);
        data.append("descRu", this.legalBrand.descRu);
        data.append("logo", this.legalBrand.logoSrc);
        data.append("lBCategoryId", this.legalBrand.lBCategoryId);
        data.append("merchants", this.legalBrand.merchants);

        let legalBrandEditResult = await this.$http.putLegalBrand(data);

        if (legalBrandEditResult.data.resultCode === "200") {
          bus.$emit("success", "სპეციალური ნივთის წარმატებით დარედაქტირდა");
          let legalBrandResult = await this.$http.getLegalBrand();
          this.legalBrandsArray = legalBrandResult.data.res;
          this.mainImageUpuloadName = "Choose FIle ...";
          this.editImg = false;
        } else {
          bus.$emit(
            "warning",
            "სპეციალური ნივთის რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteLegalBrand() {
      try {
        let legalBrandDeleteResult = await this.$http.deleteLegalBrand(
          this.legalBrand.id
        );

        if (legalBrandDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის კატეგორია წარმატებით წაიშალა");
          let legalBrandResult = await this.$http.getLegalBrand();
          this.legalBrandsArray = legalBrandResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის კატეგორიის წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      let legalBrandResult = await this.$http.getByIDLegalBrand(row.id);
      let data = legalBrandResult.data.res;

      this.legalBrand = {
        id: data.id,
        nameGe: data.nameGe,
        nameEn: data.nameEn,
        nameRu: data.nameRu,
        descGe: data.descGe,
        descEn: data.descEn,
        descRu: data.descRu,
        logoSrc: data.logoSrc,
        lBCategoryId: data.lbCategory.id,
      };
      this.mainImageUpuloadName = this.legalBrand.logoSrc;
      this.dropDownLegalBrandCategory = this.getLegalCategoryName(
        this.legalBrand.lBCategoryId
      );
    },
    getLegalCategoryName(id) {
      let legalCategoryIndex = this.legalCategoriesArray.findIndex(
        (d) => d.id === id
      );
      if (legalCategoryIndex !== -1) {
        return this.legalCategoriesArray[legalCategoryIndex].nameGe;
      }
    },
    getDeleteId(id) {
      this.legalBrand.id = id;
    },
    async dropDownCategoryClick(categoryName, categoryId) {
      this.dropDownLegalBrandCategory = categoryName;
      this.legalBrandCategory.nameGe = categoryName;
      this.legalBrandCategory.id = categoryId;
      this.legalBrand.lBCategoryId = categoryId;
    },
    onFileSelected() {
      this.mainImageUpuloadName = this.$refs.file.files[0].name;
      this.legalBrand.logoSrc = this.$refs.file.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      if (this.legalBrand.logoSrc) {
        if (/\.(jpe?g|png|gif)$/i.test(this.legalBrand.logoSrc.name)) {
          reader.readAsDataURL(this.legalBrand.logoSrc);
        }
      }
    },
    onFileSelectedEdit() {
      this.mainImageUpuloadName = this.$refs.fileEdit.files[0].name;
      this.legalBrand.logoSrc = this.$refs.fileEdit.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      if (this.legalBrand.logoSrc) {
        if (/\.(jpe?g|png|gif)$/i.test(this.legalBrand.logoSrc.name)) {
          reader.readAsDataURL(this.legalBrand.logoSrc);
        }
      }
      this.editImg = true;
    },
    imageUrl(mainImageUpuloadName) {
      if (mainImageUpuloadName !== "აირჩიეთ ფაილი ...") {
        return "http://api.wisher.ge:8080" + mainImageUpuloadName;
      }
    },
    modalPrepareEdit() {
      this.isActive = true;
    },
    modalPrepare() {
      this.isActive = false;
    },
    searchData() {
      this.filteredDataArray = this.legalBrandsArray.filter(
        (item) =>
          item.nameGe.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      );
    },
    clearData() {
      this.legalBrand.id = null;
      this.legalBrand.nameGe = "";
      this.legalBrand.nameEn = "";
      this.legalBrand.nameRu = "";
      this.legalBrand.descGe = "";
      this.legalBrand.descEn = "";
      this.legalBrand.descRu = "";
      this.legalBrand.logoSrc = null;
      this.legalBrand.lBCategoryId = null;
      this.legalBrand.merchants = [];
      this.legalBrandCategory.id = null;
      this.legalBrandCategory.nameGe = "";
      this.legalBrandCategory.nameRu = "";
      this.legalBrandCategory.nameEn = "";
      this.legalBrandCategory.iconSrc = null;
      this.mainImageUpuloadName = "აირჩიეთ ფაილი ...";
      this.dropDownLegalBrandCategory = "აირჩიეთ კატეგორია";
      // this.$refs.file.value = null
      this.showPreview = false;
      this.imagePreview = null;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/LegalBrand.vue